import React, { useContext } from 'react';
import './OfferMail.scss';
import MyContext from '../../Uttis/MyContext';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';

const OfferMail = () => {
  const { showOfferForm, setShowOfferForm,fetchStudents, savenameid, url, setMessage, setSnack, setLoading } = useContext(MyContext);

  return (
    <>
      {showOfferForm && (
        <div className="offermodal-overlay" onClick={() => setShowOfferForm(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Send Offer Letter to <b>{savenameid.name}</b></h3>
              <span className="close-icon" onClick={() => setShowOfferForm(false)}>
                &times;
              </span>
            </div>

            <Formik
              initialValues={{
                 offerdate: '',
                jobtitle: savenameid.techopted || '',
                startdate: '',
                enddate: '',
                workmode: '',
                manager: '',
                timing: '', 
              }}
              validationSchema={Yup.object({
                offerdate: Yup.string().required('Offer letter date is required'),
                jobtitle: Yup.string().required('Job title is required'),
                startdate: Yup.string().required('Start date is required'),
                enddate: Yup.string().required('End date is required'),
                workmode: Yup.string().required('Work mode is required'),
                manager: Yup.string().required('Manager name is required'),
                timing: Yup.string().required('Timing is required'), 
              })}
              onSubmit={async (values, { resetForm }) => {
                setLoading(true);
                document.querySelector("body").style.overflow = "hidden";
                try {
                  const payload = {
                    id: savenameid.id,
                    ...values
                  };
                  const { data } = await axios.post(`${url}/offer-mail`, payload);
                  if (data.success) {
                    setSnack(true);
                    setMessage(data.message);
                    fetchStudents(); 
                    resetForm();
                    setShowOfferForm(false);
                  } else {
                    setSnack(true);
                    setMessage(data.message);
                  }
                } catch (error) {
                  console.error("Error sending email:", error);
                  setSnack(true);
                  setMessage("Something went wrong while sending the email.");
                } finally {
                  setLoading(false);
                  document.querySelector("body").style.overflow = "auto";
                }
              }}
            >



              <Form className="email-form">


               <label>Offer Letter Date</label>
    <Field name="offerdate" type="date" />
    <ErrorMessage name="offerdate" component="div" className="error" />


                <label>Job Title</label>
                <Field name="jobtitle" type="text" />
                <ErrorMessage name="jobtitle" component="div" className="error" />

                <label>Start Date</label>
                <Field name="startdate" type="date" />
                <ErrorMessage name="startdate" component="div" className="error" />

                <label>End Date</label>
                <Field name="enddate" type="date" />
                <ErrorMessage name="enddate" component="div" className="error" />

            

                <label>Work Mode</label>
                <Field as="select" name="workmode">
                  <option value="">Select</option>
                  <option value="Online">Online</option>
                  <option value="Offline">Offline</option>
                  <option value="Hybrid">Hybrid</option>
                </Field>
                <ErrorMessage name="workmode" component="div" className="error" />

                <label>Reporting Manager</label>
                <Field name="manager" type="text" />
                <ErrorMessage name="manager" component="div" className="error" />

                <label>Timing</label>
                <Field name="timing" type="text" placeholder="e.g., 8 AM to 11 AM" />
                <ErrorMessage name="timing" component="div" className="error" />

                <div className="form-buttons">
                  <button type="submit">Send Offer Letter</button>
                </div>
              </Form>
            </Formik>
          </div>
        </div>
      )}
    </>
  );
};

export default OfferMail;
